import React, { FC } from 'react';
import { Box, Container } from '@mui/material';
import BeneficiaryPageHeader from './components/BeneficiaryPageHeader';
import BeneficiaryList from './components/BeneficiaryList';

const RegistrationBeneficiariesPage: FC = () => {
  return (
    <Box>
      <Container maxWidth="xl">
        <BeneficiaryPageHeader />
        <BeneficiaryList />
      </Container>
    </Box>
  );
};

export default RegistrationBeneficiariesPage;
